/* eslint-disable react/jsx-no-useless-fragment */
import {useAppSelector} from 'src/redux/store';
import React from 'react';
import { Roles } from 'src/utils/roles/roles';

type ComponenteProtegidoProps = {
	rolesPermitidos: Roles[];
	children: React.ReactNode;
};

function ComponenteProtegido({rolesPermitidos, children}: ComponenteProtegidoProps) {
	const estadoUsuario = useAppSelector((estadoApp) => estadoApp?.usuario ?? null);

	if (estadoUsuario && estadoUsuario.rolActivo && rolesPermitidos) {
		let puedeAcceder = false;
			if (rolesPermitidos.includes(estadoUsuario.rolActivo.id)) {
				puedeAcceder = true;
			}
		if (puedeAcceder) {
			return <>{children}</>;
		}
	}

	return null;
}

export default ComponenteProtegido;
